import EntitySelector from '@components/EntitySelector'

import type { EntitiesState } from '@redux/entities'

import type { TrainingLessonModel } from '@models/types'

interface TrainingLessonAliasSelectorProps {
  callbacks: {
    selectTrainingLesson: (item: TrainingLessonModel) => void,
  },
  currentTrainingLesson?: EntitiesState['trainingLessons'],
  url?: string,
}

const TrainingLessonAliasSelector = (props: TrainingLessonAliasSelectorProps) => {
  const {
    callbacks: { selectTrainingLesson },
    currentTrainingLesson,
    url,
  } = props

  return (
    <EntitySelector
      callbacks={{
        // @ts-expect-error TS2345
        selectItem: trainingLesson => selectTrainingLesson(trainingLesson),
      }}
      endpoint="training_lessons.json"
      entityKey="trainingLessons"
      goToHref={url}
      label="Alias For"
      searchForwardProps={{
        closeOnSelect: true,
        setStringOnSelect: true,
        showOnFocus: true,
      }}
      searchRequestOptions={{
        exclude_aliased: 'true',
        include_training_lesson_course: 'true',
      }}
      secondaryTextKey="training_course.title"
      // @ts-expect-error TS2322
      selectedIds={[currentTrainingLesson?.id]}
      // @ts-expect-error TS2322
      selectedItemId={currentTrainingLesson?.lesson_alias_id}
    />
  )
}

export default TrainingLessonAliasSelector
